import { ModalController, NavParams } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-blacklist-add-item',
    templateUrl: './blacklist-add-item.component.html',
    styleUrls: ['./blacklist-add-item.component.scss'],
})
export class BlacklistAddItemComponent implements OnInit {

    private data: string[] = [];
    private campaigns: any[] = [];

    public NewKeywords: { Name: string, Campaign: any }[] = [];

    public Form: FormGroup;

    private onSave: Function;
    private showToast: Function;
    private showAlert: Function;

    constructor(private NavParams: NavParams,
        private ModalController: ModalController
    ) {

        this.data = this.NavParams.get('data') || [];
        this.campaigns = this.NavParams.get('campaigns') || [];
        this.onSave = this.NavParams.get('onSave') || null;
        this.showToast = this.NavParams.get('showToast') || null;
        this.showAlert = this.NavParams.get('showAlert') || null;

        console.log(this.campaigns);


        this.Form = new FormGroup({
            Keyword: new FormControl(null, [Validators.required, Validators.minLength(2)]),
            Campaign: new FormControl(null, [])
        })
    }

    ngOnInit() { }

    OnAddAndVerify(ev: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        this.Form.markAllAsTouched();

        if (this.Form.get('Keyword').invalid) return;


        const text: string = this.Form.get('Keyword').value || "";

        console.log(text);

        console.log(this.data);

        if (!this.NewKeywords.find(it => it?.Name?.toLowerCase().match(text.toLowerCase())))
            this.NewKeywords.push({ Name: text, Campaign: null });

        this.Form.get('Keyword').reset();

    }


    OnDeleteKeyword(ev: any, item) {

        ev?.preventDefault();
        ev?.stopPropagation();

        console.log(item);

        this.NewKeywords = this.NewKeywords.filter(it => it?.Name.toLowerCase() != item?.Name.toLowerCase());

    }

    Close() {

        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }

    async OnSave(ev: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        if (this.NewKeywords?.length == 0) {

            if (this.showToast) this.showToast("Sem palavras adicionadas")
            return;
        }

        if (!this.onSave) return;

        const response = await this.onSave(this.NewKeywords)

        if (response)
            this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);

    }

}
